class ProductInfoTab extends HTMLElement {
    constructor() {
        super();
        this.switchs = this.querySelectorAll('.product-info-tab-switch');
        this.swiperEl = this.querySelector('.product-info-tab-contents');
        this.slides = this.swiperEl.querySelectorAll('.swiper-slide');
    }

    connectedCallback() {
        this.initSwiper();
        this.initComponent();
        this.descriptionFunction();
    }

    initComponent() {
        this.switchs[0].classList.add('active');

        this.switchs.forEach((switchEl, index) => {
            switchEl.addEventListener('click', (e) => {
                e.preventDefault();
                this.switchs.forEach((switchEl) => {
                    switchEl.classList.remove('active');
                });
                switchEl.classList.add('active');
                this.slides.forEach((slide) => {
                    slide.classList.remove('active');
                });
                const targetIndex = index;
                const targetSlide = this.slides[targetIndex];
                targetSlide.classList.add('active');
                this.swiperInstance.slideTo(targetIndex);
            });
        });
    }

    initSwiper() {
        this.swiperInstance = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            }
        });
    }

    descriptionFunction() {
        this.querySelectorAll('.product-description--clamped').forEach((description) => {
            const showButton = description.querySelector('.product-description__show');
            const textContainer = description.querySelector('.product-description__text');

            if (!showButton || !textContainer) return;

            // if (textContainer.scrollHeight <= textContainer.clientHeight) {
            //     description.classList.remove('product-description--clamped');
            //     textContainer.setAttribute('aria-expanded', 'true');
            //     return;
            // }

            showButton.addEventListener('click', (e) => {
                e.preventDefault();
                description.classList.remove('product-description--clamped');
                showButton.setAttribute('aria-expanded', 'true');
                textContainer.setAttribute('aria-expanded', 'true');
                this.swiperInstance.update();
            });
        });
    }
}

customElements.define('product-info-tab', ProductInfoTab);
